import ProductListing from '@/components/ProductListing.vue';
import i18n from '@/locales';
import { createApp } from 'vue';

const productListingAppElement = document.querySelector('#productListingApp');
if (productListingAppElement) {
  const productListingApp = createApp({});
  productListingApp.use(i18n)
    .component('ProductListing', ProductListing);
  productListingApp.mount('#productListingApp');
}
